function dashboard () {
	const elId = '#app-dashboard';
	const elClass = '.js-vue-dashboard';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const app = new Vue({
		el: elId,
		data: {
			dashboards: [],
			activeFilter: [],
			selectedDashboard: null,
			selectedDashboardShowFilters: false,
			filtersLoaded: false,
			filters: [],
			undoFilter: [],
			selectionFilter: null,
			charts: [],
			searchFiltersData: '',
			searchFilters: [],
			error: null,
			comparemodal: null,
			modal: null,
			compareinsightgroups: [],
			compareinsightgroupselectedleft: null,
			compareinsightgroupselectedright: null
		},
		created: function () {
			console.log(elId, 'created');
			window.toggleLoader(true);
			this.fetchData();
			$(elClass).removeClass('is-creating');
		},
		mounted: function () {
			console.log(elId, 'mounted');
			$(elClass).removeClass('is-mounting');
		},
		updated: function () {
			function cb () {
				console.log('sort stopped');
			}
			window.initSortable(cb);
		},
		methods: {
			fetchData: function () {
				const self = this;
				GET('/baas/nominow_dashboard/dashboards')
					.then(xhr => {
						const response = JSON.parse(xhr.responseText);
						// vuelog('dashboards',response);
						if (response == null || response.length == 0) {
							self.error = 'Failed to load dashboards';
							window.initToast(self.error, 'warning');
							return;
						}
						response.sort((a, b) => {
							if (a.Sortorder < b.Sortorder) {
								return -1;
							}
							if (a.Sortorder > b.Sortorder) {
								return 1;
							}
							return 0;
						});
						self.dashboards = response;
						var index = sessionStorage.getItem("selectedDashboard");
						if (!index || isNaN(index) || index >= response.length) {
							index = 0;
						}
						self.selectDashboard(response[index], index);
					})
					.catch(xhr => {
						console.log('error', xhr);
						if (typeof xhr.responseText === 'object') {
							const resp = JSON.parse(xhr.responseText);
							self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						} else if (typeof xhr.responseText === 'string' && xhr.responseText.length > 0) {
							self.error = xhr.responseText;
						} else {
							self.error = window.timeOutResponseText;
						}
					});

				GET('/baas/nominow_insight/selections').then(function (xhr) {
					var selections = JSON.parse(xhr.responseText);
					self.compareinsightgroups = selections.map(function (item) {
						var result = [];

						result.push({
							name: item.name,
							selections: item.selections
						});
						for (var ci in item.children) {
							var child = item.children[ci];
							var selections = window.cloneObject(item.selections);
							selections.push(child.selections[0])
							result.push({
								name: item.name + ' / ' + child.name,
								selections: selections
							});
						}

						return result;
					}).reduce((acc, val) => acc.concat(val), []); //.flat();
				});
			},
			toggleShowFilters: function () {
				const self = this;
				this.selectedDashboardShowFilters = true;
				const dash = this.selectedDashboard;

				// Set dashboard to null so the charts are killed and reloaded on next tick with new (filter) data
				this.selectedDashboard = null;

				Vue.nextTick(() => {
					self.selectedDashboard = dash;
					self.charts = dash.Items;
				});
				console.log(this.filters);
				this.searchFilters = this.filters;
			},

			selectDashboard: function (dash, ix) {
				window.toggleLoader(true);
				const self = this;
				// this.selectedDashboardShowFilters = false;
				this.selectedDashboard = dash;
				this.activeFilter = [];
				this.filters = [];
				this.charts = [];

				sessionStorage.setItem('selectedDashboard', ix);

				const newDash = `dashboard-${new Date().getTime()}`;
				if (!this.selectedDashboard.template || this.selectedDashboard.template.indexOf('nominow-dashboard-tile') < 0) {
					window.initToast('Template does not contain nominow-dashboard-tile elements', 'error');
				} else {
					const htmltest = `<script id="scriptfor-${newDash}">Vue.component("${newDash}", {props: [\"dashboard\", \"charts\"],template:\`${this.selectedDashboard.template}\`, created: function(){vuelog("created", this.charts);}});</script>`;
					$('body').append(htmltest);
				}

				// vuelog('charts', dash.Name, charts);
				// set next charts array in next tick so old highchart objects are killed first
				Vue.nextTick().then(() => {
					self.selectedDashboard.componentName = newDash;
					self.charts = dash.Items;
					self.loadFilters();
				});

				window.toggleLoader(false);
			},
			loadFilters: function () {
				const self = this;
				this.filters = [];
				this.filtersLoaded = false;
				//vuelog('filtertypes', this.selectedDashboard.FilterTypes);
				for (let i = 0; i < this.selectedDashboard.FilterTypes.length; i++) {
					const index = i;
					let filter = this.selectedDashboard.FilterTypes[i];
					//CHECK FOR NEW FILTER
					var isnew = false;
					if (filter.hasOwnProperty("FilterName")) {
						isnew = true;
						var newFilter = {
							TagCode: filter.FilterName,
							TagName: filter.FilterDescription,
							TagType: filter.FilterType
						}
						if (filter.filtervalues && filter.filtervalues.length > 0) {
							newFilter.items = filter.filtervalues.map(function (item) { return { key: item.FilterValues, value: item.FilterValues } });
						}
						filter = newFilter;
						//console.log('NEWFILTER', filter.hasOwnProperty("FilterName"), filter);
					}
					// reset filter values
					filter.value = undefined;
					filter.arrayvalue = undefined;
					if (!isnew && (filter.TagType == 'Multiple-select' || filter.TagType == 'Multiple-select-date')) {
						this.loadFilterValues(index, filter);
					} else {
						Vue.set(self.filters, index, filter);
						if (self.filters.length == self.selectedDashboard.Filters.length) {
							self.filtersLoaded = true;
						}
					}
				}
			},
			loadFilterValues: function (index, filter) {
				const self = this;
				GETCACHEDSESSION(`/baas/nominow_insight/filtervalues?TagCode=${filter.TagCode}`)
					.then(xhr => {
						// console.log('loaded filter', index, xhr.responseText);
						const response = JSON.parse(xhr.responseText);
						if (response.ErrorCode != undefined) {
							self.error = response.Message != '' ? response.Message : window.timeOutResponseText;
						} else {
							const filterItems = response;
							filter.items = filterItems;
							Vue.set(self.filters, index, filter);
							if (self.filters.length == self.selectedDashboard.Filters.length) {
								self.filtersLoaded = true;
							}
						}
					})
					.catch(xhr => {
						console.log('error', xhr);
						if (typeof xhr.responseText === 'object') {
							const resp = JSON.parse(xhr.responseText);
							self.error = resp.Message != '' ? resp.Message : window.timeOutResponseText;
						} else if (typeof xhr.responseText === 'string' && xhr.responseText.length > 0) {
							self.error = xhr.responseText;
						} else {
							self.error = window.timeOutResponseText;
						}
					});
			},
			filterChartData: function () {
				this.getCheckedElements();
				// TODO:  merge with selectDashboard
				window.toggleLoader(true);
				const self = this;
				const dash = this.selectedDashboard;
				// dit zorgt voor de data
				this.activeFilter = this.getFilterObject();

				this.charts = [];
				const charts = [];
				for (let i = 0; i < dash.Items.length; i++) {
					const chart = dash.Items[i];
					if (chart.IsActive) {
						// append filter
						chart.filter = self.activeFilter;
					}
				}

				this.toggleShowFilters(dash);

				window.toggleLoader(false);
			},
			getCheckedElements: function () {
				const allInputs = document.querySelectorAll('.filter-card-wrapper input[type=checkbox]');
				const allTextInputs = document.querySelectorAll('.filter-card-wrapper input[type=text]');

				for (let i = 0; i < allInputs.length; i++) {
					if (allInputs[i].checked !== false && !allInputs[i].getAttribute('active-in-filter')) {
						allInputs[i].setAttribute('active-in-filter', 'true');
					} else if (allInputs[i].checked == false && allInputs[i].getAttribute('active-in-filter')) {
						allInputs[i].removeAttribute('active-in-filter');
					}
				}
				for (let i = 0; i < allTextInputs.length; i++) {
					if (allTextInputs[i].value.trim('') !== '' && !allTextInputs[i].getAttribute('active-in-filter')) {
						allTextInputs[i].setAttribute('active-in-filter', 'true');
					} else if (allTextInputs[i].value.trim('') == '' && allTextInputs[i].getAttribute('active-in-filter')) {
						allTextInputs[i].removeAttribute('active-in-filter');
					}
				}
			},
			undoCheckElements: function () {
				const allInputs = document.querySelectorAll('.filter-card-wrapper input[type=checkbox]:checked');
				const allTextInputs = document.querySelectorAll('.filter-card-wrapper input[type=text]');

				for (let i = 0; i < allInputs.length; i++) {
					if (allInputs[i].value !== false && !allInputs[i].getAttribute('active-in-filter')) {
						allInputs[i].checked = false;
					}
				}

				for (let i = 0; i < allTextInputs.length; i++) {
					if (allTextInputs[i].value !== null && !allTextInputs[i].getAttribute('active-in-filter')) {
						allTextInputs[i].value = '';
					}
				}
			},
			getFilterObject: function () {
				const result = [];
				const self = this;
				// get filters with value
				console.log(this);
				const activefilters = Array.prototype.filter.call(this.filters, f => (f.value != null && f.value != '') || (f.arrayvalue != null && f.arrayvalue.length > 0));
				const obj = [{
					type: 'INTERSECT',
					filters: Array.prototype.map.call(activefilters, (f, i) => ({
						type: 'include',
						tagCode: f.TagCode,
						value: f.value,
						arrayvalue: f.arrayvalue || [],
						maxvalue: f.maxvalue,
						valueop: f.valueop
					}))
				}];

				Vue.nextTick().then(() => {
					self.animateChosenValue();
				});

				// console.log('filter', obj);
				return obj;
			},

			getFilterString: function (f) {
				return this.chosenValue(f);
			},

			getFilterForTagCode: function (tagCode) {
				const fltrs = this.activeFilter && this.activeFilter.length > 0 ? this.activeFilter[0].filters : [];
				const found = fltrs.find(element => element.tagCode.toUpperCase() === tagCode.toUpperCase());

				return found;
			},

			getFilterTags: function () {
				const result = [];
				const fltrs = this.activeFilter && this.activeFilter.length > 0 ? this.activeFilter[0].filters : [];
				for (let i = 0; i < this.activeFilter[0].filters.length; i++) {
					var active = this.activeFilter[0].filters[i];
					const filter = window.cloneObject(Array.prototype.find.call(this.filters, f => f.TagCode == active.tagCode));
					if (filter) {
						filter.value = active.value;
						filter.arrayvalue = active.arrayvalue;

						result.push({
							TagCode: active.tagCode,
							TagName: filter.TagName,
							Value: filter.value,
							ArrayValue: filter.arrayvalue,
							Filter: filter,
							ChosenValue: this.chosenValue(filter, true)
						});
					} else {
						console.log('failed to find filter in list', active);
					}
				}
				// console.log(result);
				return result;
			},

			undoLastFilter: function () { },
			removeFilter: function (tagCode) {
				for (let i = 0; i < this.filters.length; i++) {
					if (this.filters[i].TagCode == tagCode) {
						this.filters[i].value = null;
						this.filters[i].maxvalue = null;
						this.filters[i].arrayvalue = null;
						this.filters[i].valueop = null;
					}
				}
				Vue.nextTick().then(() => {
					$('.js-filters .validation-error').removeClass('validation-error');
				});
				this.filterChartData();
			},
			chosenValue: function (f, showFull) {
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				// NOTE: Copied from segmentbuilder with slight modifications
				let chosenValue = '';
				if (f == null) {
					chosenValue = 'No values chosen.';
				} else if (f.TagType == 'Multiple-select' || f.TagType == 'Multiple-select-date' || f.TagType == 'Time-serie') {
					if (f.items != null && f.items.length > 0 && f.arrayvalue.length > 0) {
						let result = '';
						for (var i = 0; i < f.arrayvalue.length; i++) {
							const val = Array.prototype.find.call(f.items, it => it.key == f.arrayvalue[i]);
							if (val == null) continue;
							if (i > 0) {
								result += ', ';
							}
							if (i == 3 && showFull != true) {
								result += `...${f.arrayvalue.length} total`;
								break;
							}
							result += val.value;
						}
						chosenValue = result;
					} else {
						chosenValue = 'Select values';
					}
					if (f.TagType == 'Multiple-select-date') {
						var o = f.valueop == null ? 'Select operation' : f.valueop;
						var v = f.value == null ? '...' : f.value;
						var mv = f.maxvalue == null ? '...' : f.maxvalue;
						if (o == 'isnull') {
							v = '';
							o = 'Is Not Set';
						}
						if (o == 'notnull') {
							v = '';
							o = 'Is Set';
						}
						chosenValue += ` ${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
					}
				} else if (f.TagType == 'Boolean') {
					chosenValue = f.value ? 'Has tag' : 'Does not have tag';
				} else if (f.TagType == 'Text') {
					chosenValue = f.value == null || f.valueop == '' ? '' : f.value;
				} else if (f.TagType == 'Date') {
					var o = f.valueop == null ? 'Select operation' : f.valueop;
					var v = f.value == null ? '...' : f.value;
					var mv = f.maxvalue == null ? '...' : f.maxvalue;
					if (o == 'isnull') {
						v = '';
						o = 'Is Not Set';
					}
					if (o == 'notnull') {
						v = '';
						o = 'Is Set';
					}
					chosenValue = `${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
				} else if (f.TagType == 'Int') {
					var o = f.valueop == null ? 'Select operation' : f.valueop;
					var v = f.value == null ? '...' : f.value;
					var mv = f.maxvalue == null ? '...' : f.maxvalue;
					if (o == 'isnull') {
						v = '';
						o = 'Is Not Set';
					}
					if (o == 'notnull') {
						v = '';
						o = 'Is Set';
					}
					chosenValue = `${o} ${v}${o == 'Between' ? ` and ${mv}` : ''}`;
				}
				return chosenValue;
			},
			animateChosenValue: function () {
				// get the max width of the div and calculate the new width for animation
				// var maxWidth = document.querySelector(".js-filter-tags .tags").clientWidth;

				// add eventlistener for mouse in and out
				const tagAnimation = document.querySelectorAll('.js-has-animated-tag-span .js-tag-animation');
				// add the css animation to the child element of .has-animated-tag-span
				const tagAnimationSpan = document.querySelectorAll('.js-has-animated-tag-span .js-tag-animation span');
				// init animation duration
				let animationDur = 0;

				// get the class js-is-pulled-left and if its bigger than 1000px give it the inline style width 100% to prevent overflow
				const overflowFix = document.querySelectorAll('.js-filter-tags .js-is-pulled-left');

				// loop through all span tags
				for (let i = 0; i < overflowFix.length; i++) {
					if (overflowFix[i].clientWidth > 1000) {
						// using ES6 block-scope with "let" to prevent undefined error when adding the class
						const animateWidth = overflowFix[i].clientWidth - 750;
						const tagA = tagAnimation[i];
						const tagAS = tagAnimationSpan[i];

						// get animation duration based on width of animateWidth
						if (animateWidth >= 25000) {
							animationDur = 200;
						} else if (animateWidth < 25000 && animateWidth > 10000) {
							animationDur = 150;
						} else if (animateWidth < 10000 && animateWidth > 5000) {
							animationDur = 80;
						} else if (animateWidth < 5000 && animateWidth > 2000) {
							animationDur = 50;
						} else {
							animationDur = 15;
						}

						// add width for overflow fix for all animated tag spans that are bigger than 1000px
						overflowFix[i].style.width = '100%';

						// Add inline css when user hovers over the span tag
						tagA.addEventListener('mouseover', () => {
							// animateWidth value to move the text to the left with a negative value
							// animationDur gets calculated to keep the animation from going to fast
							tagAS.style.cssText = `transform: translateX(-${animateWidth}px); transition-duration:${animationDur}s; transition-timing-function: linear;`;
						});
						// Add inline css when user moves away from the span tag
						tagA.addEventListener('mouseout', () => {
							// Adds inline css to reset the animation
							tagAS.style.cssText = 'transform: translateX(0px); transition-duration: 2s; transition-timing-function: linear;';
						});
					}
				}
			},
			recalculateComparedChart: function () {
				var self = this;
				var newChartRight = window.cloneObject(this.comparemodal.filterChart);
				newChartRight.filter = this.compareinsightgroupselectedright ? this.compareinsightgroupselectedright.selections : null;

				var oldstr = JSON.stringify(this.comparemodal.filterChart);
				var newstr = JSON.stringify(newChartRight);
				if (oldstr != newstr) {
					this.comparemodal.filterChart = null;
					Vue.nextTick(function () {
						self.comparemodal.filterChart = newChartRight;
					});
				}


				var newChartLeft = window.cloneObject(this.comparemodal.originalChart);
				newChartLeft.filter = this.compareinsightgroupselectedleft ? this.compareinsightgroupselectedleft.selections : null;

				var oldstrright = JSON.stringify(this.comparemodal.originalChart);
				var newstrright = JSON.stringify(newChartLeft);
				if (oldstrright != newstrright) {
					this.comparemodal.originalChart = null;
					Vue.nextTick(function () {
						self.comparemodal.originalChart = newChartLeft;
					});
				}
			},
			closemodals: function () {
				this.comparemodal = null;
			},

			btnCreateNewDashboard: function () {
				// copied from settings-dashboard
				const self = this;

				const cancel = function () {
					self.modal = null;
				};

				const submit = function () {
					if (window.isInputValid('.modal-card-body')) {
						const name = self.modal.input.field;
						const dashboard = {
							Name: name,
							Sortorder: 0,
							TableName: 'DashContactProfile',
							Filters: [],
							Items: []
						};
						self.dashboards.push(dashboard);
						self.setActiveDashboard(
							self.dashboards[self.dashboards.length - 1]
						);
						self.saveDashboard();
						console.log('create new dashboard');
						self.modal = null;
					}
				};

				const createNewDashboardModal = {
					id: 'createNewDashboardModal',
					cardtitle: 'Create dashboard page',
					buttoncolor: 'is-primary',
					buttontitle: 'Create',
					buttoncanceltitle: 'Cancel',
					input: {
						type: 'text',
						label: 'Dashboard Name',
						placeholder: 'Name',
						required: true
					},
					onCancel: cancel,
					onSubmit: submit
				};
				this.modal = createNewDashboardModal;
			},
			setActiveDashboard: function (item, ix) {
				this.selectedDashboard = item;
			},
			addDashboardItem: function () {
				if (this.selectedDashboard) {
					const ix = this.selectedDashboard.Items.length;
					Vue.set(this.selectedDashboard.Items, ix, {
						Dimension1: []
					});
					this.selectItem(this.selectedDashboard.Items[ix], ix);
				}
			},
			saveDashboard: function () {
				const self = this;
				this.selectedDashboard.FilterTypes = [];
				for (let i = 0; i < this.selectedDashboard.Filters.length; i++) {
					const tagCode = this.selectedDashboard.Filters[i];
					const filter = Array.prototype.find.call(this.filters, el => el.key == tagCode);
					this.selectedDashboard.FilterTypes.push(filter.filter);
				}
				delete this.selectedDashboard.navSubItems;

				window.toggleLoader(true);
				if (this.selectedDashboard._id == null) {
					const json = {
						json: JSON.stringify(this.selectedDashboard)
					};
					POST('/baas/nominow_dashboard/dashboards', json)
						.then(xhr => {
							window.initToast('Saved', 'success');
							self.fetchData();

							console.log(xhr.responseText);
						})
						.catch(xhr => {
							window.initToast('Failed to save', 'danger');
							console.log(xhr.responseText);
						});
				} else {
					const json = {
						filter: JSON.stringify({
							_id: this.selectedDashboard._id
						}),
						json: JSON.stringify(this.selectedDashboard)
					};
					PUT('/baas/nominow_dashboard/dashboards', json)
						.then(xhr => {
							window.initToast('Saved', 'success');
							self.fetchData();
						})
						.catch(xhr => {
							window.initToast('Failed to save', 'danger');
							console.log(xhr.responseText);
						});
				}
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
dashboard();
